export function initHomeSelect(main: HTMLDivElement) {

	let obs = new IntersectionObserver(
		(es) => {
			es.forEach(
				(e) => {
					if (e.isIntersecting) {
						obs.disconnect();
						run();
					}
				}
			)
		},
		{
			rootMargin: '-20% 0px -20% 0px'
		}
	);
	obs.observe(main);

	function run() {
		main.classList.remove('before');
	}

}
